import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/index.vue";
import Mine from "../views/mine/index.vue";

Vue.use(VueRouter);

const routes = [{
        path: "*",
        redirect: "/",
    },
    {
        path: "/",
        name: "Home",
        component: Home,
        meta: {
            layout: "home",
            data: "home",
            requiresAuth: true,
        },
    },
    {
        path: "/access-forbid",
        name: "access",
        meta: {
            isShow: true,
            footer: true,
            requiresAuth: true,
        },
        component: () =>
            import ("../views/403.vue"),
    },
    {
        path: "/game/sport",
        name: "sport",
        meta: {
            layout: "game",
            data: "sport",
            requiresAuth: true,
        },
        component: () =>
            import ("../views/game/sport.vue"),
    },
    {
        path: "/game/realbet",
        name: "realbet",
        meta: {
            layout: "game",
            data: "realbet",
            requiresAuth: true,
        },
        component: () =>
            import ("../views/game/sport.vue"),
    },
    {
        path: "/game/chess",
        name: "chess",
        meta: {
            layout: "game",
            data: "chess",
            requiresAuth: true,
        },
        component: () =>
            import ("../views/game/sport.vue"),
    },
    {
        path: "/game/gaming",
        name: "gaming",
        meta: {
            layout: "game",
            data: "gaming",
            requiresAuth: true,
        },
        component: () =>
            import ("../views/game/sport.vue"),
    },
    {
        path: "/game/lottery",
        name: "lottery",
        meta: {
            layout: "game",
            data: "lottery",
            requiresAuth: true,
        },
        component: () =>
            import ("../views/game/sport.vue"),
    },
    {
        path: "/game/egame",
        name: "egame",
        meta: {
            layout: "game",
            data: "egame",
            requiresAuth: true,
        },
        component: () =>
            import ("../views/game/sport.vue"),
    },
    {
        path: "/game/fishing",
        name: "fishing",
        meta: {
            layout: "game",
            data: "fishing",
            requiresAuth: true,
        },
        component: () =>
            import ("../views/game/sport.vue"),
    },
    {
        path: "/activity/discount",
        name: "activity",
        meta: {
            data: "discount",
            requiresAuth: true,
        },
        component: () =>
            import ("../views/activity/discount.vue"),
    },
    {
        path: "/vipIntroduce",
        name: "vipIntroduce",
        meta: {
            data: "vipIntroduce",
            requiresAuth: true,
        },
        component: () =>
            import ("../views/vipIntroduce.vue"),
    },
    {
        path: "/vipTravel",
        name: "vipTravel",
        meta: {
            data: "vipTravel",
            requiresAuth: true,
        },
        component: () =>
            import ("../views/vipTravel.vue"),
    },
    {
        path: "/sportIntroduce",
        name: "sportIntroduce",
        meta: {
            data: "sportIntroduce",
            requiresAuth: true,
        },
        component: () =>
            import ("../views/sportIntroduce.vue"),
    },
    {
        path: "/download",
        name: "download",
        meta: {
            data: "download",
            layout: "download",
            footer: false,
            requiresAuth: true,
        },
        component: () =>
            import ("../views/download.vue"),
    },
    {
        path: "/activity/bettingGift",
        name: "bettingGift",
        meta: {
            data: "bettingGift",
            layout: "bettingGift",
        },
        component: () =>
            import ("../views/activity/bettingGift.vue"),
    },
    {
        path: "/activity/activityLandPage",
        name: "activityLandPage",
        meta: {
            requiresAuth: true,
        },
        component: () =>
            import ("../views/activity/activityLandPage.vue"),
    },
    {
        path: "/activity/activityLandPageFl",
        name: "activityLandPageFl",
        meta: {
            requiresAuth: true,
        },
        component: () =>
            import ("../views/activity/activityLandPageFl.vue"),
    },

    {
        path: "/finance/deposit",
        name: "deposit",
        meta: {
            isShow: true,
            head: 1,
            type: 'deposit'
        },
        component: () =>
            import ("../views/finance/deposit.vue"),
    },
    {
        path: "/finance/transfer",
        name: "transfer",
        meta: {
            isShow: true,
            head: 1,
            type: 'transfer'
        },
        component: () =>
            import ("../views/finance/transfer.vue"),
    },
    {
        path: "/finance/withdrawal",
        name: "withdrawal",
        meta: {
            isShow: true,
            head: 1,
            type: 'withdrawal'
        },
        component: () =>
            import ("../views/finance/withdrawal.vue"),
    },
    {
        path: "/mine",
        component: Mine,
        redirect: "/mine/userInfo",
        children: [{
                path: "/mine/userInfo",
                name: "userInfo",
                meta: {
                    isShow: true,
                },
                component: () =>
                    import ("../views/mine/userInfo.vue"),
            }, {
                path: "/mine/accountInfo",
                name: "accountInfo",
                meta: {
                    isShow: true,
                },
                component: () =>
                    import ("../views/mine/accountInfo.vue"),
            }, , {
                path: "/mine/usersecure",
                name: "usersecure",
                meta: {
                    isShow: true,
                },
                component: () =>
                    import ("../views/mine/usersecure.vue"),
            },
            {
                path: "/mine/vip",
                name: "vip",
                meta: {
                    isShow: false,
                },
                component: () =>
                    import ("../views/mine/vip.vue"),
            },
            {
                path: "/mine/details",
                name: "details",
                meta: {
                    isShow: false,
                },
                component: () =>
                    import ("../views/mine/details.vue"),
            },
            {
                path: "/record/welfare",
                name: "welfare",
                component: () =>
                    import ("../views/record/welfare.vue"),
            },
            {
                path: "/record/transRecord",
                name: "transRecord",
                component: () =>
                    import ("../views/record/transRecord.vue"),
            },
            {
                path: "/record/betRecord",
                name: "betRecord",
                component: () =>
                    import ("../views/record/betRecord.vue"),
            },
            {
                path: "/record/giftRecord",
                name: "giftRecord",
                component: () =>
                    import ("../views/record/giftRecord.vue"),
            },
            {
                path: "/finance/introTutorial",
                name: "introTutorial",
                component: () =>
                    import ("../views/finance/introTutorial.vue"),
                meta: {
                    requiresAuth: true,
                },
            },
            {
                path: "/finance/wallet",
                name: "wallet",
                meta: {
                    isShow: true,
                },
                component: () =>
                    import ("../views/finance/wallet.vue"),
            },
            {
                path: "/mail",
                name: "mail",
                component: () =>
                    import ("../views/mine/mail.vue"),
            },
            {
                path: "/addBankCard",
                name: "feedbackAdd",
                meta: {
                    isShow: true,
                },
                component: () =>
                    import ("../views/mine/addBankCard.vue"),
            },
            {
                path: "/virtualCoinCard",
                name: "virtualCoinCard",
                meta: {
                    isShow: true,
                },
                component: () =>
                    import ("../views/mine/virtualCoinCard.vue"),
            },
            {
                path: "/ebpayAccount",
                name: "ebpayAccount",
                meta: {
                    isShow: true,
                },
                component: () =>
                    import ("../views/mine/ebpay/ebpayAcount.vue"),
            },
        ],
    },
    {
        path: "/help/index/:id/:title",
        name: "Help",
        component: () =>
            import ("../views/help/home.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/message",
        name: "message",
        component: () =>
            import ("../views/message.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/feedback",
        name: "feedback",
        meta: {
            isShow: true,
        },
        component: () =>
            import ("../views/mine/feedback.vue"),
    },
    {
        path: "/feedback/list",
        name: "feedbackList",
        meta: {
            isShow: true,
        },
        component: () =>
            import ("../views/mine/feedbackList.vue"),
    },
    {
        path: "/feedback/detail",
        name: "feedbackDetail",
        meta: {
            isShow: true,
        },
        component: () =>
            import ("../views/mine/feedbackDetail.vue"),
    },
    {
        path: "/sports/index/:id/:type",
        name: "sports",
        meta: {
            requiresAuth: true,
        },
        component: () =>
            import ("../views/sports/index.vue"),
    },
    {
        path: "/agen/index",
        name: "agenHome",
        meta: {
            head: 2,
            requiresAuth: true,
            mapState: 'agenHome'
        },
        component: () =>
            import ("../views/agen/index.vue"),
    },
    {
        path: "/agen/about",
        name: "agenAbout",
        meta: {
            head: 2,
            requiresAuth: true,
            mapState: 'agenAbout'
        },
        component: () =>
            import ("../views/agen/about.vue"),
    },
    {
        path: "/agen/produce",
        name: "agenProduce",
        meta: {
            head: 2,
            requiresAuth: true,
            mapState: 'agenProduce'
        },
        component: () =>
            import ("../views/agen/produce.vue"),
    },
    {
        path: "/agen/welfare",
        name: "agenWelfare",
        meta: {
            head: 2,
            requiresAuth: true,
            mapState: 'agenWelfare'
        },
        component: () =>
            import ("../views/agen/welfare.vue"),
    },
    {
        path: "/agen/case",
        name: "agenCase",
        meta: {
            head: 2,
            requiresAuth: true,
            mapState: 'agenCase'
        },
        component: () =>
            import ("../views/agen/case.vue"),
    },
    {
        path: "/agen/qa",
        name: "agenQa",
        meta: {
            head: 2,
            requiresAuth: true,
            mapState: 'agenQa'
        },
        component: () =>
            import ("../views/agen/qa.vue"),
    },
];

const router = new VueRouter({
    mode: "hash",
    base: process.env.BASE_URL,
    routes,
});
// 判断将去路由是否存在
let checkRoute = (path) => {
    let len = router.getRoutes().filter((item) => item.path == path).length;
    if (len) return true;
    else return false;
};

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};

// 检测是否登录
router.beforeEach((to, from, next) => {
    const token = localStorage.getItem("AppToken");
    if (to.meta.requiresAuth) {
        next();
    } else {
        if (token) {
            next();
        } else {
            // console.log(to.path);
            next("/");
        }
    }
});

export default router;